<template>
  <div :id="id" :class="inputGroupClasses">
    <slot name="prepend">
      <div v-if="prepend || prependHtml" class="input-group-prepend">
        <span v-if="prependHtml" ref="prependHtml" class="input-group-text" />
        <span v-if="prepend" class="input-group-text">{{ prepend }}</span>
      </div>
    </slot>

    <slot />
    <slot name="append">
      <div v-if="append || appendHtml" class="input-group-append">
        <span v-if="appendHtml" ref="appendHtml" class="input-group-text" />
        <span v-if="append" class="input-group-text">{{ append }}</span>
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  name: "BInputGroup",
  props: {
    id: {
      type: String,
      default: null,
    },
    tag: {
      type: String,
      default: "div",
    },
    size: {
      type: String,
      default: null,
      validator: (value) => ["sm", "lg"].includes(value),
    },
    append: {
      type: String,
    },
    appendHtml: {
      type: String,
    },

    prependHtml: {
      type: String,
    },

    prepend: {
      type: String,
    },
  },

  computed: {
    inputGroupClasses() {
      return [
        "input-group",
        this.size ? `input-group-${this.size}` : null,
        this.prepend ? "input-group-prepend" : null,
        this.append ? "input-group-append" : null,
      ];
    },
  },
  watch: {
    appendHtml() {
      this.$nextTick(() => {
        this.$refs.appendHtml.innerHTML = this.appendHtml;
      });
    },
    prependHtml() {
      this.$nextTick(() => {
        this.$refs.prependHtml.innerHTML = this.prependHtml;
      });
    },
  },
};
</script>
